import { render, staticRenderFns } from "./RsaConfigurazioneSettingLivelliEditPage.vue?vue&type=template&id=bd1869b6"
import script from "./RsaConfigurazioneSettingLivelliEditPage.vue?vue&type=script&lang=js"
export * from "./RsaConfigurazioneSettingLivelliEditPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports